import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './Logo.css';

const Logo = ({ size, className }) => (
  <div className={`logo logo-${size} ${className}`}>
    <Link to="/campaigns">
      <img src="/images/inmarket_logo_640w.png" alt="In Market" />
    </Link>
  </div>
);

Logo.defaultProps = {
  size: '',
  className: '',
};

Logo.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
};

export default Logo;
